import {Button, Box} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'

const TermsModal = ({onShowTermsModal}) => {
  const {t} = useTranslation('points')

  return (
    <Box py="md" borderBottom="1px solid" borderColor="mld.neutral.100">
      <Button variant="secondary" onClick={onShowTermsModal}>
        {t('points:qantasConnectionDrawer.termsModal.button')}
      </Button>
    </Box>
  )
}

TermsModal.propTypes = {
  onShowTermsModal: PropTypes.func.isRequired,
}

export default TermsModal
